<app-site-menu
    (closeSiteMenu)="onCloseSiteMenu()"
    [isLoggedIn$]="isLoggedIn$"
    [activatedComponent]="activatedComponent"
    [languages]="languages"
    [currentLanguage]="currentLanguage"
    (loggedOut)="logout()"
    (languageSwitched)="switchLanguage($event)"
    (search)="search($event)">
</app-site-menu>
